export default "__VITE_ASSET__V$5buSel__"